import React, { useMemo } from "react";

import Order from "../../../../../../../services/Order";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const CustomerFullNameCellContent: React.FC<
	CustomerFullNameCellContent.Props
> = ({ item }) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.CustomerFullName];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item);
	}, [item]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CustomerFullNameCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default CustomerFullNameCellContent;
